var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bulletBox",staticClass:"model-bullet"},[_c('canvas',{ref:"bulletCanvas",staticClass:"bullet-canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }